
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetType = typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetType[keyof typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetType = {
  REPLIED_TO: 'REPLIED_TO',
  QUOTED: 'QUOTED',
  RETWEETED: 'RETWEETED',
} as const;
